export default function PageHeader({ title, subtitle, icon: Icon, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
      <div className="flex items-start gap-3">
        {Icon && (
          <div className="h-11 w-11 rounded-xl bg-navy-900 flex items-center justify-center shrink-0 shadow-sm">
            <Icon className="h-5 w-5 text-white" strokeWidth={2} />
          </div>
        )}
        <div>
          <h1 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight text-navy-900">{title}</h1>
          {subtitle && <p className="text-sm text-slate-500 mt-0.5">{subtitle}</p>}
        </div>
      </div>
      {children && <div className="flex items-center gap-2 flex-wrap">{children}</div>}
    </div>
  );
}
